// frontend/src/components/QuickFilterChips.jsx
export default function QuickFilterChips({ onFilterApply }) {
  // IMPORTANT: these keys/values should match backend /api/search expectations
  const quickFilters = [
    { id: "high_risk", label: "HIGH RISK", icon: "🔴", filters: { risk_level: ["high", "very_high"] } },
    { id: "due_review", label: "DUE FOR REVIEW", icon: "📋", filters: { review_status: ["overdue", "due_soon"] } },
    { id: "coc_overdue", label: "COC OVERDUE", icon: "⚠️", filters: { coc_status: ["overdue"] } },
    { id: "screening", label: "SCREENING HITS", icon: "🎯", filters: { screening_status: ["hits"] } },
    { id: "new_clients", label: "NEW CLIENTS", icon: "👥", filters: { created_within: "30" } },
    { id: "international", label: "INTERNATIONAL", icon: "🌍", filters: { residency_status: ["international", "foreign"] } },
  ];

  return (
    <div style={{ marginBottom: 24 }}>
      <div style={{ fontSize: 13, fontWeight: 600, color: "var(--text-secondary)", marginBottom: 12 }}>Quick Filters</div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
        {quickFilters.map((qf) => (
          <button
            key={qf.id}
            type="button"
            onClick={() => onFilterApply(qf.filters)}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              padding: "8px 16px",
              borderRadius: 999,
              border: "1px solid var(--border-primary)",
              background: "var(--surface)",
              color: "var(--text-primary)",
              fontSize: 13,
              fontWeight: 600,
              cursor: "pointer",
              transition: "all 0.15s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "var(--surface-hover)";
              e.currentTarget.style.borderColor = "var(--accent-primary)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "var(--surface)";
              e.currentTarget.style.borderColor = "var(--border-primary)";
            }}>
            <span>{qf.icon}</span>
            <span>{qf.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
